import { HexagramIcon } from './HexagramIcon';

/**
 * author: Michael Irigoyen
 * id A965D069-BF40-4F96-B64D-6C1C93F0E2E3
 * name hexagram
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hexagram.svg
 * tags
 * - Shape 
 * - Holiday 
 */
export const ChristmasStarIcon = HexagramIcon;
export default ChristmasStarIcon